/**
 * @file: useTermsOfServiceTextContent.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import { safeMarkDevFlag } from '@euler/utils';
import { convert as html2text } from 'html-to-text';
import { useEffect, useState } from 'react';

const kForceDefaultContent = safeMarkDevFlag(true);

export const useTermsOfServiceTextContent = (
  storeConfiguredContent: string | undefined,
) => {
  const [content, setContent] = useState<string>();

  useEffect(() => {
    if (storeConfiguredContent && !kForceDefaultContent) {
      const s = convertHtmlToText(storeConfiguredContent).trim();
      if (s) {
        setContent(s);
        return;
      }
    }
    //Fix: rn_fetch_blob_ WEBPACK_IMPORTED_MODULE_4__.default.fetch is not a function
    fetch('https://zhichetech.com/terms-of-service.default.html')
      .then(res => {
        const status = res.status;
        if (status === 200) {
          res
            .text()
            .then(data => {
              const s = convertHtmlToText(data.replace(/<h1.*?>.+?<\/h1>/, ''));
              setContent(s);
            })
            .catch(error => console.error(error));
        }
      })
      .catch(error => {
        console.error(error);
      });
  }, [storeConfiguredContent]);

  return content;
};

export function convertHtmlToText(html: string) {
  return html2text(html);
}
